export const pluralise = (count: number, noun: string): string =>
	`${count} ${noun}${count === 1 ? '' : 's'}`;
